import React, { ButtonHTMLAttributes, Fragment } from "react";

type ButtonPrimaryModalProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text?: string;
  loader?: boolean;
};

export const ButtonPrimaryModal: React.FC<ButtonPrimaryModalProps> = ({
  text,
  loader,
  ...props
}) => (
  <div className="flex-row gap-2 px-3 bg-primary-500 hover:bg-primary-400 transition-colors duration-200 rounded-md items-center justify-center flex  ">
    {loader && (
      <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />
    )}

    <button
      {...props}
      type="button"
      className="inline-flex justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white "
    >
      {text}
    </button>
  </div>
);
